var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sport",class:[{active: _vm.elementIsActive},{default: !_vm.elementIsActive}, _vm.element.color],on:{"click":function($event){return _vm.changeFilter()}}},[_vm._v(_vm._s(_vm.element.ru))])
}
var staticRenderFns = []

export { render, staticRenderFns }